import React from "react";
import PropTypes from "prop-types";
import { useRouteMatch } from "react-router";

import { Button } from "rhombus-react";
import Permissioned from "widgets/Permissioned";

import { decisioningActions } from "widgets/grid/cells/VersionActionLists/Decisioning";
import { dtreeDropdownAllowables } from 'utils/VersionActions';

export default function DecisioningButton({ isDisabled, dependentValues }){
	let { url } = useRouteMatch();
	let actions = decisioningActions({ url, dependentValues });

	return (
		<Permissioned any={dtreeDropdownAllowables}>
			<Button key="decisioning" disabled={isDisabled} icon="dtree" theme="blue" style="block" isDropDown splitActions={actions} splitValue="decisioning-button" >Decisioning</Button>
		</Permissioned>
	);
}

DecisioningButton.propTypes = {
	isDisabled: PropTypes.bool,
};
DecisioningButton.displayName = "DecisioningButton";
